import { AdminAppointmentTurn } from "./AdminConfirmation.interfaces";

export const AdminTurnConfirmationConvertResponse = (
  res: AdminAppointmentTurn
) => {
  const data = res.appointments.map((appointment) => {
    return {
      id: appointment.appointment_id,
      appointmentNum: appointment.appointment_num,
      volantes: appointment.volantes,
      agentName: appointment.agent_name,
      vehicles: appointment.vehicles,
      plates: appointment.vehicles.map((vehicle) => vehicle.plate),
      timeslotStart: appointment.timeslot.start,
      timeslotEnd: appointment.timeslot.end,
      weight: appointment.parcels_weight_sum,
      groups: appointment.groups_num_sum,
      segmentCategory: appointment.segment_category?.label,
      dispatcher: appointment.customs_dispatcher_json.full_name,
      dispatcherDocumentNumber:
        appointment.customs_dispatcher_json.document_number,
      updatedAt: appointment.updated_at,
      withdrawalDate: appointment.withdrawal_date,
      withdrawalByHand: appointment.hand_pick_up,
      dockNum: appointment.dock_num,
      turnNum: appointment.turn_num,
    };
  });

  return {
    data,
    num_pages: res.num_pages,
    page_size: res.page_size,
    count: res.count,
    page: res.page,
  };
};
